import { EyeOutlined , DeleteOutlined } from "@ant-design/icons";
import { Button, Col, Popover, Row, Space, Table } from 'antd'
import React, { useState } from 'react'
import commonUtility from "../../utility/Utils";
import { useEffect } from "react";

const content = (
    <div>
      <p>Content</p>
      <p>Content</p>
    </div>
  );

const TapBookingGeneratedSchedule = ({ tapbookingGeneratedSchedule , removeBooking }) => {

    const [scheduleDates,setScheduleDates] = useState([]);
    const showDates = (data) => {
        setScheduleDates(dateListView(data));
    }


    const [scheduleHolidaysDates,setScheduleHolidaysDates] = useState([]);
    const showHolidayDates = (data) => {
        setScheduleHolidaysDates(holidayListView(data));
    }



    const dateListView = (data) => {
        return data.map((x, index) => (
          <div key={index}>
            <p style={{ margin: '0.2rem 0', borderBottom: '1px solid #f7f7f7' }}>{x}</p>
          </div>
        ));
      };


      const holidayListView = (data) => {
        return data.map((x, index) => (
          <div key={index}>
            <p style={{ margin: '0.2rem 0', borderBottom: '1px solid #f7f7f7' }}>{x.holiday_date} ({x.holiday_description})</p>
          </div>
        ));
      };
    



    const columns = [
        // {
        //     title: 'Type',
        //     dataIndex: 'tap_group_txt',
        //     key: 'tap_group_txt',
        // },
        // {
        //     title: 'Trainee/Member',
        //     dataIndex: 'trainee_member',
        //     key: 'trainee_member',
        // },
        {
            title: 'Coach',
            dataIndex: 'is_with_coach_txt',
            key: 'is_with_coach_txt',
            render: (text, record, index) => (
                <>
                    <p>{record.coach_detail_txt != null > 0 ? record.coach_detail_txt : "" }</p>
                    <p>{record.is_with_coach_txt != null > 0 ? record.is_with_coach_txt : "" }</p>
                </>
            )
        },
        
       
        {
            title: 'Day',
            dataIndex: 'day_name',
            key: 'day_name',
        },
        {
            title: 'Time Slot',
            dataIndex: 'time_slot',
            key: 'time_slot',
            render: (text, record, index) => (
                <>
                  {
                    record.time_slot  ? <>
                    <p style={{margin:0}}>{record.time_slot} </p>
                  
                    <h4>
                      {/* <span onClick={()=>showMonths(render.detailsData.receipt_master_id)}>{render.detailsData.no_of_months} </span> */}
                      <Popover content={scheduleDates} title="Dates" trigger="click"
                      onClick={()=>showDates(record.available_dates)}
                      >
                        <Button danger size="small">View {record.no_of_days} Date</Button>
                      </Popover>

                      </h4>

                      {/* {
                        record.no_of_holiday > 0 ? <>
                        <h4>
                      <Popover content={scheduleHolidaysDates} title="Holiday Dates" trigger="click"
                      onClick={()=>showHolidayDates(record.holidayDates)}
                      >
                        <Button danger size="small">View {record.no_of_holiday} Holidays</Button>
                      </Popover>

                      </h4>
                        </> : <></>
                      }
                       */}
                {
                    record.no_of_holiday > 0 ? <>
                    <h4>
                      <Popover content={scheduleHolidaysDates} title="Holiday Dates" trigger="click"
                      onClick={()=>showHolidayDates(record.holidayDates)}
                      >
                        <Button danger size="small">View {record.no_of_holiday} Holidays</Button>
                      </Popover>

                      </h4>
                    </> : <></>
                }
                        

                       
                      {/* {record.holiday_list ? (
                        <>
                            <p>
                            <strong>Holiday ListX</strong>
                            <br />
                            {record.holiday_list.split(",").map((item, index) => (
                                <React.Fragment key={index}>
                                {item.trim()}
                                <br />
                                </React.Fragment>
                            ))}
                            </p>
                        </>
                        ) : (
                        ""
                        )} */}
                        
                    </> : ''

                   
                    
                  }
                </>
             )
        },
        {
            title: 'No Of Days',
            dataIndex: 'no_of_days',
            key: 'no_of_days',
        },
        {
            title: 'Rate / Slot',
            dataIndex: 'rate_per_slot',
            key: 'rate_per_slot',
        },
        {
            title: 'Total Value',
            dataIndex: 'total_value',
            key: 'total_value',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record, index) => (
              
                <Space size="middle">
                    <Button htmlType="button" type="danger" size="small" shape="round" onClick={()=> removeBooking(index)} title="Delete"><DeleteOutlined /></Button>
                </Space>
            ),
          },
    ];
    


    useEffect(()=>{
        console.log('TapBookingGenerateSchedule');
    },[])

    return (
        <div>
            {
                tapbookingGeneratedSchedule.length > 0 ? <>
                    <Table key={tapbookingGeneratedSchedule.unique_id} columns={columns} dataSource={tapbookingGeneratedSchedule} pagination={false} size="small" />
                </> : ''
            }
        </div>
    )
}

export default TapBookingGeneratedSchedule